export type UserRole = 'admin' | 'editor' | 'moderator' | 'user';

export interface RolePermissions {
  can_manage_ai: boolean;
  can_manage_blog: boolean;
  can_manage_comments: boolean;
  can_manage_users: boolean;
  can_manage_downloads: boolean;
  can_manage_team: boolean;
  can_manage_terms: boolean;
  can_manage_contacts: boolean;
  can_manage_roles: boolean;
  can_manage_yektanet: boolean;
}

export const DEFAULT_ROLE_PERMISSIONS: Record<UserRole, RolePermissions> = {
  admin: {
    can_manage_ai: true,
    can_manage_blog: true,
    can_manage_comments: true,
    can_manage_users: true,
    can_manage_downloads: true,
    can_manage_team: true,
    can_manage_terms: true,
    can_manage_contacts: true,
    can_manage_roles: true,
    can_manage_yektanet: true,
  },
  editor: {
    can_manage_ai: true,
    can_manage_blog: true,
    can_manage_comments: false,
    can_manage_users: false,
    can_manage_downloads: true,
    can_manage_team: false,
    can_manage_terms: true,
    can_manage_contacts: false,
    can_manage_roles: false,
    can_manage_yektanet: false,
  },
  moderator: {
    can_manage_ai: false,
    can_manage_blog: false,
    can_manage_comments: true,
    can_manage_users: false,
    can_manage_downloads: false,
    can_manage_team: false,
    can_manage_terms: false,
    can_manage_contacts: false,
    can_manage_roles: false,
    can_manage_yektanet: false,
  },
  user: {
    can_manage_ai: false,
    can_manage_blog: false,
    can_manage_comments: false,
    can_manage_users: false,
    can_manage_downloads: false,
    can_manage_team: false,
    can_manage_terms: false,
    can_manage_contacts: false,
    can_manage_roles: false,
    can_manage_yektanet: false,
  },
};

export interface RoleAssignment {
  id?: string;
  email: string;
  role: UserRole;
  custom_permissions?: Partial<RolePermissions>;
  assigned_by?: string;
  created_at?: string;
  updated_at?: string;
}

export const PERMISSION_LABELS: Record<keyof RolePermissions, string> = {
  can_manage_roles: 'مدیریت نقش‌ها و سطوح دسترسی (RBAC)',
  can_manage_ai: 'مدیریت و اجرای ایجنت‌های هوش مصنوعی',
  can_manage_blog: 'مدیریت و انتشار مقالات بلاگ',
  can_manage_comments: 'تایید و نظارت بر کامنت‌ها',
  can_manage_users: 'مشاهده و مدیریت کاربران',
  can_manage_downloads: 'مدیریت لینک‌های دانلود و بازی‌ها',
  can_manage_team: 'مدیریت اعضای تیم',
  can_manage_terms: 'مدیریت قوانین و مقررات',
  can_manage_contacts: 'مدیریت راه‌های ارتباطی (تماس با ما)',
  can_manage_yektanet: 'مدیریت تبلیغات و اسپانسرها',
};

export const ROLE_LABELS: Record<UserRole, { title: string; color: string; desc: string }> = {
  admin: {
    title: 'مدیر کل (Super Admin)',
    color: 'from-amber-500 to-yellow-400 text-black',
    desc: 'دسترسی نامحدود به تمامی بخش‌های مدیریتی و تنظیمات پلتفرم',
  },
  editor: {
    title: 'سردبیر / نویسنده (Editor)',
    color: 'from-blue-600 to-cyan-500 text-white',
    desc: 'دسترسی به بخش وبلاگ، ایجنت‌های تولید محتوا، دانلودها و قوانین',
  },
  moderator: {
    title: 'ناظر انجمن (Moderator)',
    color: 'from-emerald-600 to-teal-400 text-white',
    desc: 'دسترسی به تایید، پین کردن و پاسخ به نظرات کاربران',
  },
  user: {
    title: 'کاربر عادی (Regular User)',
    color: 'from-zinc-700 to-zinc-600 text-gray-300',
    desc: 'دسترسی استاندارد به بازی‌ها، مطالعه بلاگ و ثبت نظر',
  },
};
